import API from "../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const createLeave = createAsyncThunk(
  "leave/createLeaveStatus",
  async (params = {}) => {
    try {
      const {
        data: { data },
      } = await API.post(`leave/createLeave`, params);
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
);

const getAllLeaves = createAsyncThunk(
  "leave/getAllLeavesStatus",
  async (params = {}) => {
    try {
      const response = await API.post(`leave/getAllLeaves`, params);
      const data = response?.data?.data ?? response?.data;
      // Return array only when present; otherwise undefined so reducer keeps previous list
      return Array.isArray(data) ? data : undefined;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }
);

const getLeaveDetails = async (leave_id) => {
  try {
    const response = await API.get(`leave/getLeaveDetails/${leave_id}`);
    if (response.status === 200) return response.data.data;
    else return response.message;
  } catch (error) {
    console.log(error);
    return error.message;
  }
};

const updateLeave = async (params) => {
  try {
    const { leave_id, ...updateData } = params;
    const response = await API.put(`leave/updateLeave/${leave_id}`, updateData);
    if (response.status === 200 && response.data?.status === 1) {
      return {
        status: true,
        message: response.data?.message || "Leave updated successfully",
      };
    }
    return {
      status: false,
      message: response.data?.message || response.message || "Error updating leave",
    };
  } catch (error) {
    return {
      status: false,
      message:
        error.response?.data?.message || error.message || "Error updating leave",
    };
  }
};

const approveLeave = async (leave_id) => {
  try {
    const response = await API.get(`leave/approveLeave/${leave_id}`);
    if (response.status === 200)
      return { status: true, message: "Leave approved successfully" };
    else return { status: false, message: response.message };
  } catch (error) {
    return { status: false, message: error.message };
  }
};

const rejectLeave = async (params) => {
  try {
    const { leave_id, rejected_comments } = params;
    const response = await API.put(`leave/rejectLeave/${leave_id}`, {
      rejected_comments,
    });
    if (response.status === 200)
      return { status: true, message: "Leave rejected successfully" };
    else return { status: false, message: response.message };
  } catch (error) {
    return { status: false, message: error.message };
  }
};

const deleteLeave = async (leave_id) => {
  try {
    const response = await API.delete(`leave/deleteLeave/${leave_id}`);
    if (response.status === 200 && response.data && response.data.status === 1) {
      return {
        status: true,
        message: response.data.message || "Leave deleted successfully",
      };
    } else {
      return {
        status: false,
        message: response.data?.message || "Error deleting leave",
      };
    }
  } catch (error) {
    console.error("Error deleting leave:", error);
    if (error.response) {
      const errorMessage =
        error.response.data?.message ||
        error.response.statusText ||
        "Error deleting leave";
      return { status: false, message: errorMessage };
    }
    return { status: false, message: error.message || "Error deleting leave" };
  }
};

const getLeaveBalance = createAsyncThunk(
  "leave/getLeaveBalanceStatus",
  async (params = {}) => {
    try {
      const {
        data: { data },
      } = await API.get(`leave/getLeaveBalance`, { params });
      return data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
);

const getLeaveStatistics = createAsyncThunk(
  "leave/getLeaveStatisticsStatus",
  async () => {
    try {
      const {
        data: { data },
      } = await API.get(`leave/getLeaveStatistics`);
      return data;
    } catch (error) {
      console.log(error);
      return null;
    }
  }
);

// Admin: grant comp-off leave(s) to employees
const addCompOff = createAsyncThunk(
  "leave/addCompOffStatus",
  async (params = {}) => {
    try {
      const { data } = await API.post(`leave/addCompOff`, params);
      // Expect shape: { status, message, data: {...} }
      return data;
    } catch (error) {
      console.log(error);
      return { status: 0, message: error.message || "Failed to add comp off" };
    }
  }
);

export {
  createLeave,
  getAllLeaves,
  getLeaveDetails,
  updateLeave,
  approveLeave,
  rejectLeave,
  deleteLeave,
  getLeaveBalance,
  getLeaveStatistics,
  addCompOff,
};

